import React, { useContext } from 'react';
import { Container, Typography } from '@pwskills/rachnaui';
import Slider from '@pwskills/rachnaui/components/Slider';
import Headers from '@/components/common/Header';
import CourseDescriptionContext from '@/context/CourseDescriptionContext';
import { companyImage } from '@/utils/common/env.constants';
import Growth from '../../common/Icons/courseDescription/Growth';
import Money from '../../common/Icons/courseDescription/Money';
import Transition from '../../common/Icons/courseDescription/Transition';
import Work from '../../common/Icons/courseDescription/Work';
import ToolsCard from './ToolsCard';

const AlumniSection = () => {
  const { courseDetails } = useContext(CourseDescriptionContext);
  const { placementCompanies, statsInfo } = courseDetails?.courseMetaDetails || {};
  const { careerTransitions, highestSalary, averageSalaryHike, hiringPartner } = statsInfo || {};

  return (
    <div>
      {(careerTransitions ||
        highestSalary ||
        averageSalaryHike ||
        hiringPartner ||
        (placementCompanies && placementCompanies?.length > 0)) && (
        <section
          id="placement"
          data-title="Placement"
          className="bg-gradient-to-b  from-white to-[#F9F9F9]"
        >
          <Container className="flex flex-col py-8 large:!py-14">
            {placementCompanies && placementCompanies?.length > 0 && (
              <>
                <Headers
                  title="Our Alumni's Are Placed At"
                  classes="flex !min-w-full w-full justify-center text-gray-850 pb-6 large:!pb-14 medium:w-auto text-center !self-center !w-[50%]  medium:!w-full  "
                />
                <div className="hidden medium:!grid medium:grid-cols-4 mt-[10px] last:col-span-[1/span 2] large:grid-cols-5  medium:gap-x-[40px] medium:gap-y-6 items-center justify-between flex-grow-0 pb-8 large:!pb-14">
                  {placementCompanies?.map((company) => (
                    <figure className="shrink-0 flex justify-center items-center" key={company._id}>
                      <img
                        src={`${companyImage}/company_logos/${company?.companyLogoFileName}`}
                        alt={company?.name}
                        className="w-[80%] aspect-[4/2] object-contain mix-blend-darken"
                      />
                    </figure>
                  ))}
                </div>
                <Slider
                  wrapperClass="medium:!hidden"
                  iconWrapperClass=""
                  autoPlay
                  positionOfSliderInMobile="bottom"
                >
                  {placementCompanies?.map((company) => (
                    <ToolsCard company={company} key={company?._id} />
                  ))}
                </Slider>
              </>
            )}
            <div className="grid grid-cols-1 medium:grid-cols-2 large:grid-cols-4 gap-4 large:gap-5">
              {highestSalary && (
                <div className="large:!flex-row flex-col large:!justify-start justify-center flex items-center w-full gap-[17px] py-6 px-[14px] rounded-[12px] bg-[#DAE9F8] shrink-0">
                  <div className="bg-white shadow-medium w-12 h-12 shrink-0 rounded-[8px] flex justify-center items-center">
                    <Growth />
                  </div>
                  <div>
                    <Typography
                      component="h4"
                      variant="bold"
                      className="font-inter large:!text-start text-center"
                    >
                      {averageSalaryHike}
                    </Typography>
                    <Typography
                      component="subheading"
                      variant="regular"
                      className=" text-center text-gray-850 large:!text-start"
                    >
                      Average Salary
                    </Typography>
                  </div>
                </div>
              )}
              {averageSalaryHike && (
                <div className="large:!flex-row flex-col large:!justify-start justify-center flex items-center w-full gap-[17px] py-4 px-[14px] rounded-[12px] shrink-0 bg-[#D4F4D8]">
                  <div className="bg-white shadow-medium w-12 h-12 shrink-0 rounded-[8px] flex justify-center items-center">
                    <Money />
                  </div>
                  <div>
                    <Typography
                      component="h4"
                      variant="bold"
                      className="large:!text-start text-center"
                    >
                      {highestSalary}
                    </Typography>
                    <Typography
                      component="subheading"
                      variant="regular"
                      className="text-center text-gray-850 large:!text-start"
                    >
                      Highest Salary
                    </Typography>
                  </div>
                </div>
              )}
              {careerTransitions && (
                <div className="large:!flex-row flex-col large:!justify-start justify-center flex items-center gap-[17px]  w-full py-4 px-[14px]  rounded-[12px] shrink-0 bg-[#F9DBE6]">
                  <div className="bg-white shadow-medium w-12 h-12 shrink-0 rounded-[8px] flex justify-center items-center">
                    <Transition />
                  </div>
                  <div>
                    <Typography
                      component="h4"
                      variant="bold"
                      className="text-center font-inter large:!text-start "
                    >
                      {careerTransitions}
                    </Typography>
                    <Typography
                      component="subheading"
                      variant="regular"
                      className=" text-center text-gray-850 large:!text-start"
                    >
                      Career Transitions
                    </Typography>
                  </div>
                </div>
              )}
              {hiringPartner && (
                <div className="large:!flex-row flex-col large:!justify-start justify-center flex gap-[17px] items-center w-full py-4 px-[14px] rounded-[12px] bg-[#F4EAC7]">
                  <div className="bg-white shadow-medium w-12 h-12 shrink-0 rounded-[8px] flex justify-center items-center">
                    <Work />
                  </div>
                  <div>
                    <Typography
                      component="h4"
                      variant="bold"
                      className="text-center large:!text-start "
                    >
                      {hiringPartner}
                    </Typography>
                    <Typography
                      component="subheading"
                      variant="regular"
                      className=" text-center text-gray-850 large:!text-start"
                    >
                      Hiring Partners
                    </Typography>
                  </div>
                </div>
              )}
            </div>
          </Container>
        </section>
      )}
    </div>
  );
};

export default AlumniSection;
